import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`ibix-header ${isScrolled ? "ibix-header-scrolled" : ""}`}
    >
      <div className="ibix-header-container">
        {/* Logo Section */}
        <div className="">
          <div className="ibix-logo">
            {/* <div className="ibix-logo-icon">
              <i className="fas fa-graduation-cap"></i>
            </div> */}
            <img
              src="https://iqteche.in/static/media/wl_client_images/2d65766bae1c490c9cec775f6cc83ea9.png"
              alt="ibix-logo"
              className="home-nav-ico"
            />
            <div className="ibix-logo-text">
              <span className="ibix-logo-primary">IBIX</span>
              <span className="ibix-logo-secondary">Learn Hub</span>
            </div>
          </div>
        </div>

        {/* Desktop Login Section */}
        <div className="ibix-login-section">
          <Link to={"/login"} className="login-btn-link">
            <button className="ibix-login-button" aria-label="Student login">
              <i className="fas fa-sign-in-alt ibix-login-icon"></i>
              <span className="ibix-login-text">Student Login</span>
            </button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
